import { render, staticRenderFns } from "./VideoCallSubScreenList.vue?vue&type=template&id=7dd27654&scoped=true&"
import script from "./VideoCallSubScreenList.vue?vue&type=script&lang=ts&"
export * from "./VideoCallSubScreenList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallSubScreenList.vue?vue&type=style&index=0&id=7dd27654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd27654",
  null
  
)

export default component.exports